import Lottie from 'lottie-react';
import React from 'react'
import RocketLaunchLoader from '../../assets/Rocket Launch.json'

const RocketLauncherLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center h-[80vh] w-full bg-gradient-to-b from-blue-50 to-white">
          <Lottie
            animationData={RocketLaunchLoader}
            loop
            autoplay
            style={{ width: '180px', height: '180px' }}
          />
          <p className="mt-4 text-gray-600 font-medium text-lg animate-pulse">
            Launching your request... 🚀
          </p>
        </div>
      );
}

export default RocketLauncherLoader